/**
 * Detects whether the user is on a mobile device based on user agent.
 * Used to determine concurrency strategy (mobile = 1).
 */
export function isMobile(): boolean {
  return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)
}

/**
 * Checks whether the browser supports OffscreenCanvas.
 * This is a progressive enhancement — the app must work without it.
 */
export function supportsOffscreenCanvas(): boolean {
  return typeof OffscreenCanvas !== 'undefined'
}
